export const companyColumns = [
  {
    title: '编号', 
    dataIndex: 'id',
  },
  {
    title: '资料名称',
    dataIndex: 'name',
  },
  {
    title: '资料类型',
    dataIndex: 'type',
  },

  {
    title: '资料附件',
    dataIndex: 'attach_doc_info_list',
    scopedSlots: { customRender: 'attach_doc_info_list' },
  },
  // {
  //   title: '资料详情',
  //   dataIndex: 'summary',
  // },
  {
    title: '关联产品',
    dataIndex: 'product_info_title',
  },
  {
    title: '状态',
    customRender: (record)=> record.status===1?'启用':'禁用',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
export const serviceColumns = [
  {
    title: '编号',
    width: '65px',
    dataIndex: 'id',
  },
  {
    title: '合作机构',
    dataIndex: 'company_id',
    ellipsis:true,
  },
  {
    title: '资料名称',
    dataIndex: 'name',
    ellipsis:true,
    width:250
  },
  {
    title: '使用场景',
    dataIndex: 'scene',
    width: '100px',
    customRender: (text, record, index)=>{
      return record.scene===1?'传统任务':'远程任务';
    },
  },
  {
    title: '资料类型',
    width: '100px',
    dataIndex: 'type',
  },

  {
    title: '资料附件',
    dataIndex: 'attach_doc_info_list',
    scopedSlots: { customRender: 'attach_doc_info_list' },
  },

  // {
  //   title: '资料详情',
  //   dataIndex: 'summary',
  // },
  {
    title: '关联产品',
    dataIndex: 'product_info_title',
  },
  {
    title: '状态',
    width: '80px',
    customRender: (record)=> record.status===1?'启用':'禁用',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: '160px',
    scopedSlots: { customRender: 'operation' },
  },
];

export const companyFormData = [
  {
    name: 'name',
    lable: '资料名称',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'type',
    lable: '资料类型',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
 {
 	  name: 'product_id',
 	  lable: '关联产品',
 	  lableCol: 4,
 	  wrapperCol: 18,
 	  offset: 0,
 	  span: 12,
  },
  {
    name: 'upload',
    lable: '资料附件',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  
  {
    name: 'summary',
    lable: '资料详情',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
];
export const serviceFormData = [
  // {
  //   name: 'company_id',
  //   lable: '合作企业',
  //   lableCol: 4,
  //   wrapperCol: 18,
  //   offset: 0,
  //   span: 12,
  // },
  {
    name: 'scene',
    lable: '使用场景',
    lableCol: 4,
    align:'right',
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'name',
    lable: '资料名称',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },

  {
    name: 'type',
    lable: '资料类型',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
  	  name: 'product_id',
  	  lable: '关联产品',
  	  lableCol: 4,
  	  wrapperCol: 18,
  	  offset: 0,
  	  span: 12,
   },
  {
    name: 'upload',
    lable: '资料附件',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
  {
    name: 'summary',
    lable: '资料简介',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 12,
  },
];
